import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
let Cohort = class Cohort extends VuexModule {
    constructor() {
        super(...arguments);
        this.cohorts = [];
    }
    SET_COHORTS(cohorts) {
        this.cohorts = cohorts;
    }
    SetCohorts(cohorts) {
        return cohorts;
    }
};
__decorate([
    Mutation
], Cohort.prototype, "SET_COHORTS", null);
__decorate([
    Action({ commit: 'SET_COHORTS' })
], Cohort.prototype, "SetCohorts", null);
Cohort = __decorate([
    Module({ dynamic: true, store, name: 'cohort' })
], Cohort);
export const CohortModule = getModule(Cohort);
//# sourceMappingURL=cohort.js.map